import { z } from 'zod';

// ---------------------------------------------------------------------------
// Newsletter: POST /v1/newsletter/subscribe
// ---------------------------------------------------------------------------

export const NewsletterSubscribeSchema = z.object({
  email: z.string().email(),
  lang: z.string().optional(),
  site_code: z.string().optional(),
});
export type NewsletterSubscribe = z.infer<typeof NewsletterSubscribeSchema>;

export const NewsletterSubscribeResponseSchema = z.object({
  status: z.literal('pending'),
});
export type NewsletterSubscribeResponse = z.infer<typeof NewsletterSubscribeResponseSchema>;
